<template>
  <div class="gift-box">
    <div class="gift-box__received-date-area">
      <div class="minimal">
        {{ formattedReceivedDate }}
      </div>
    </div>
    <gift-card-ticket-box-header
      v-if="!isPersonalUse"
      :sender-icon="senderIcon"
      :sender-name="senderName"
      :show-usable-profile-link="showUsableProfileLink"
      :created-user-profile-path="createdUserProfilePath"
    />
    <div class="gift-box__body">
      <ticket-connected-with-link
        :link-url="url"
        :image-url="itemSkuImage"
        :item-name="itemName"
        :item-sku-name="itemSkuName"
        :brand-name="brandName"
        :expiration-date="formattedUsableLimitAt"
        :is-ticket-expired="false"
        class="gift-box__ticket"
      />
      <div class="gift-box__change-button">
        <gift-card-ticket-box-change-btn
          :ticket-id="ticketId"
          @click-button="clickButton"
        />
        <span class="minimal">
          利用した覚えのあるギフトは利用済として記録しておきましょう
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import GiftCardTicketBoxHeader from './GiftCardTicketBoxHeader.vue'
import TicketConnectedWithLink from '../../atoms/tickets/TicketConnectedWithLink.vue'
import GiftCardTicketBoxChangeBtn from './GiftCardTicketBoxChangeBtn.vue'
import dayjs from 'dayjs'

export default {
  components: {
    GiftCardTicketBoxHeader,
    TicketConnectedWithLink,
    GiftCardTicketBoxChangeBtn
  },
  props: {
    senderIcon: {
      type: String,
      required: false,
      default: ''
    },
    senderName: {
      type: String,
      required: false,
      default: ''
    },
    url: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: true
    },
    itemSkuImage: {
      type: String,
      required: true
    },
    brandName: {
      type: String,
      required: true
    },
    ticketId: {
      type: Number,
      required: true
    },
    isPersonalUse: {
      type: Boolean,
      required: true,
      default: false
    },
    receivedAt: {
      type: String,
      required: true
    },
    usableLimitAt: {
      type: String,
      required: true
    },
    showUsableProfileLink: {
      type: Boolean,
      required: false,
      default: false
    },
    createdUserProfilePath: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    formattedReceivedDate() {
      return dayjs(this.receivedAt).format('YYYY年M月D日 HH:mm')
    },
    formattedUsableLimitAt() {
      return dayjs(this.usableLimitAt).format('YYYY年M月D日まで有効')
    }
  },
  methods: {
    clickButton() {
      this.$emit('click-button')
    }
  }
}
</script>
